import api from "../../axios/axios";
import { ApiRequest, NetworkTypes, handleAndThrowError } from "../ApiError";
import { ICustomer } from "./ICustomer";

export const getCustomers = async (
  customerName: string
): Promise<ICustomer[]> => {
  // Append the customerName as a query parameter to the URL
  const url = `/api/v1/customer?customerName=${encodeURIComponent(
    customerName
  )}`;

  const request: ApiRequest = {
    endPoint: url,
    method: NetworkTypes.GET,
    baseUrl: api.getUri(),
    data: null,
  };

  // Use the modified URL with the query parameter
  const response = await api.get(url).catch((error) => {
    throw handleAndThrowError(error, request);
  });

  return response.data as ICustomer[];
};
